import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';

function OrderSearch() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [orderNumber, setOrderNumber] = useState('');
  const [barcode, setBarcode] = useState('');
  const [searchType, setSearchType] = useState('orderNumber');

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchType === 'orderNumber' && orderNumber.trim()) {
      navigate(`/tracking/${orderNumber}`);
    } else if (searchType === 'barcode' && barcode.trim()) {
      // يمكن إضافة بحث بالباركود هنا
      alert(t('Barcode search functionality can be implemented here'));
    }
  };

  return (
    <div className="page-container">
      <div className="login-buttons">
        <button onClick={() => navigate('/')}>🏠 {t('Home')}</button>
        <button onClick={() => navigate('/orders')}>📋 {t('Orders')}</button>
      </div>

      <h2>📍 {t('Order Tracking')}</h2>
      
      <div style={{
        background: 'linear-gradient(135deg, #f5f7fa, #c3cfe2)',
        padding: '30px',
        borderRadius: '15px',
        marginBottom: '30px',
        boxShadow: '0 5px 15px rgba(0,0,0,0.1)'
      }}>
        <h3 style={{textAlign: 'center', marginBottom: '20px', color: '#333'}}>
          🔍 {t('Search for Order')}
        </h3>
        
        <form onSubmit={handleSearch} style={{maxWidth: '500px', margin: '0 auto'}}>
          <div style={{marginBottom: '20px'}}>
            <label style={{display: 'block', marginBottom: '10px', fontWeight: 'bold', color: '#555'}}>
              {t('Search Type')} 🔍
            </label>
            <div style={{display: 'flex', gap: '10px', marginBottom: '15px'}}>
              <label style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                <input
                  type="radio"
                  name="searchType"
                  value="orderNumber"
                  checked={searchType === 'orderNumber'}
                  onChange={(e) => setSearchType(e.target.value)}
                />
                {t('Order Number')}
              </label>
              <label style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                <input
                  type="radio"
                  name="searchType"
                  value="barcode"
                  checked={searchType === 'barcode'}
                  onChange={(e) => setSearchType(e.target.value)}
                />
                {t('Barcode')}
              </label>
            </div>
          </div>

          {searchType === 'orderNumber' ? (
            <div style={{marginBottom: '20px'}}>
              <label style={{display: 'block', marginBottom: '10px', fontWeight: 'bold', color: '#555'}}>
                {t('Order Number')} 📋
              </label>
              <input
                type="text"
                placeholder={t('Enter order number')}
                value={orderNumber}
                onChange={(e) => setOrderNumber(e.target.value)}
                style={{width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd'}}
                required
              />
            </div>
          ) : (
            <div style={{marginBottom: '20px'}}>
              <label style={{display: 'block', marginBottom: '10px', fontWeight: 'bold', color: '#555'}}>
                {t('Barcode')} 📊
              </label>
              <input
                type="text"
                placeholder={t('Enter barcode')}
                value={barcode}
                onChange={(e) => setBarcode(e.target.value)}
                style={{width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd'}}
                required
              />
            </div>
          )}

          <button 
            type="submit" 
            style={{
              width: '100%',
              padding: '15px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'background-color 0.3s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#218838'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#28a745'}
          >
            🔍 {t('Search Order')}
          </button>
        </form>
      </div>

      <div style={{
        background: 'linear-gradient(135deg, #667eea, #764ba2)',
        padding: '20px',
        borderRadius: '15px',
        color: 'white',
        textAlign: 'center'
      }}>
        <h3 style={{marginBottom: '15px'}}>ℹ️ {t('How to Track')}</h3>
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px'}}>
          <div>
            <strong>📋 {t('Order Number')}</strong>
            <p style={{fontSize: '14px', marginTop: '5px'}}>
              {t('Enter the order number to track your delivery')}
            </p>
          </div>
          <div>
            <strong>📊 {t('Barcode')}</strong>
            <p style={{fontSize: '14px', marginTop: '5px'}}>
              {t('Scan or enter the barcode for quick tracking')}
            </p>
          </div>
          <div>
            <strong>📍 {t('Real-time Updates')}</strong>
            <p style={{fontSize: '14px', marginTop: '5px'}}>
              {t('Get live updates on your order status')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrderSearch;
